import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

interface ConfirmModalProps {
  message: string;
  inputText: string | null;
  inputDescription: string | null;
  onConfirm: (
    event: React.MouseEvent<HTMLButtonElement>,
    text: string,
    description: string
  ) => void;
  onCancel: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  message,
  inputText,
  inputDescription,
  onConfirm,
  onCancel,
}) => {
  const [text, setText] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  useEffect(() => {
    if (inputText) {
      setText(inputText);
    }
  }, [inputText]);

  useEffect(() => {
    if (inputDescription) {
      setDescription(inputDescription);
    }
  }, [inputDescription]);

  const updateValue = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    e.stopPropagation();
    setText(e.target.value);
  };

  return (
    <div
      className="cm-modal-overlay"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <div
        className="cm-modal-content"
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <h3>{message}</h3>

        {inputText !== null && (
          <InputText
            id="text"
            type="text"
            placeholder="Enter text"
            className="cm-input"
            style={{ fontSize: "16px" }}
            value={text}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setText(e.target.value)
            }
          />
        )}
        {inputDescription !== null && (
          <InputTextarea
            id="description"
            placeholder="Enter description"
            rows={5}
            cols={30}
            className="cm-input cm-input-textarea"
            style={{ fontSize: "16px" }}
            value={description}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setDescription(e.target.value)
            }
          />
        )}
        <div className="cm-modal-buttons">
          <button
            className="cm-button"
            onClick={(e) => {
              if (inputText !== null && text.trim() === "") {
                alert("Please enter a text.");
                document.getElementById("text")?.focus();
                return;
              }
              if (inputDescription !== null && description.trim() === "") {
                alert("Please enter a description.");
                document.getElementById("description")?.focus();
                return;
              }
              onConfirm(e, text, description);
            }}
          >
            Yes
          </button>
          <button className="cm-button" onClick={onCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
